/* eslint-disable @typescript-eslint/no-empty-function */
import { Component } from '@angular/core';
import { ReceiptSaleService } from './receipt-sale.service';
@Component({
  selector: 'pg-receipt-sale',
  templateUrl: './receipt-sale.component.html'
})
export class ReceiptSaleComponent {
  selectedReceipt = null;
  receipts = this.receiptSaleService.receipts;

  constructor(private receiptSaleService: ReceiptSaleService) {}

  ngOnInit() {
    this.selectedReceipt = this.receiptSaleService.getData();
  }

  onSelectReceipt(event) {
    this.receiptSaleService.setData(event);
  }
}
